export default __webpack_public_path__ + "static/media/TotalSelf.b86bd711.svg";